import usePrivateAxios from '@/common/api/usePrivateAxios';
import { ErrorResponse } from '@/common/types/errorResponse';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

interface UseMaintenanceFiscalAssessmentSimpleEntriesRegressProps {
  fiscalAssessmentEntryId: string | undefined;
  options?: Partial<Omit<UseMutationOptions<
    unknown,
    ErrorResponse
  >, 'mutationKey' | 'mutationFn'>>;
}

export const useMaintenanceFiscalAssessmentSimpleEntriesRegress = ({
  fiscalAssessmentEntryId,
  options,
}: UseMaintenanceFiscalAssessmentSimpleEntriesRegressProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['maintenanceFiscalAssessmentSimpleEntriesRegress'],
    mutationFn: () => {
      return privateAxios.put(`/maintenance/fiscal_assessment/simple_entries/${fiscalAssessmentEntryId}/regress`);
    },
    ...options
  });
}
